<template>
  <div id="search-result">
    <div id="title">{{ $t('SEARCH_RESULT') }}</div>
    <ul>
      <li v-if="notFound">{{ $t('NO_DATA_WAS_NOT_FOUND')}}</li>
      <li v-if="limitSearched">{{ $t('NOTIFICATION_SEARCHED_QUERY_RESULTED_MORE_THAN_200_RECORDS')}}</li>
      <li v-for="client in clients.slice(0, 100)"
          :key="`client-${client.id}`"
      >
        <div v-if="search.searchType !== types[2]">
          <div>
            <span><router-link :to="applyParams(PATHS.CLIENT_DETAIL, client.id)">{{ client.fullName }}</router-link></span> | {{ client.primaryPhone }}
            <p><strong>{{ $t('CLIENT') }}</strong> | {{ $t('BRANCH') }}: {{ client.branchName }}</p>
          </div>
        </div>

      </li>
      <li v-for="contract in contracts.slice(0, 100)"
          :key="`contract-${contract.id}`"
      >
        <div v-if="search.searchType !== types[1]">
          <span><router-link :to="applyParams(PATHS.CONTRACT_DETAIL, contract.mifosId)">{{ contract.product.productDesc }}</router-link></span> |
          {{ $t('CNTRCT_ID') }}: {{ contract.mifosId }}
          <p><strong>{{ $t('CONTRACTS') }}</strong> | {{ $t('CLIENT') }}:
            <span><router-link :to="applyParams(PATHS.CLIENT_DETAIL, contract.client.id)">{{ contract.client.name }}</router-link></span>
          </p>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { onMounted, ref, watch } from '@vue/composition-api';
import { createNamespacedHelpers } from 'vuex-composition-helpers';

import { applyParams } from '@/helpers';
import { PATHS } from '@/consts';
import SearchResultService from './SearchResultService';

const { useState: useSearchState } = createNamespacedHelpers('searchResult');

export default {
  name: 'SearchResult',
  components: {

  },
  metaInfo() {
    const { $i18n } = this;
    const title = $i18n.t('SEARCH_RESULT');

    return {
      title,
      meta: []
    };
  },
  setup() {
    const searchResultList = ref([]);
    const contracts = ref([]);
    const clients = ref([]);
    const notFound = ref(false);
    const limitSearched = ref(false);
    const types = ['all', 'clients', 'contracts'];

    const { search } = useSearchState(['search']);

    const checkNotFound = (list) => {
      if (list.length < 1) {
        notFound.value = true;
      } else if (list.length > 200) {
        limitSearched.value = true;
      } else {
        notFound.value = false;
      }
    };

    const getSearchResult = async () => {
      if (search.value.terms) {
        if (search.value.searchType === types[2]) {
          const { items } = await SearchResultService.getContractList(search.value);
          contracts.value = items;
          checkNotFound(contracts.value);
        } else if (search.value.searchType === types[1]) {
          const { items } = await SearchResultService.getClientList(search.value);
          searchResultList.value = items;
          clients.value = items;
          checkNotFound(clients.value);
        } else {
          const { items: clientList } = await SearchResultService.getClientList(search.value);
          const { items: contractList } = await SearchResultService.getContractList(search.value);
          searchResultList.value = clientList.concat(contractList);
          clients.value = clientList;
          contracts.value = contractList;
          checkNotFound(searchResultList.value);
        }
      }
    };

    watch(search, () => {
      getSearchResult();
    });

    onMounted(() => {
      getSearchResult();
    });

    return {
      searchResultList,
      PATHS,
      applyParams,
      clients,
      contracts,
      search,
      types,
      notFound,
      limitSearched
    };
  }
};
</script>

<style lang="scss">
@import "~@/assets/scss/colors";

#search-result {
  padding: 32px 30px;

  #title {
    font-size: 28px;
    margin-bottom: 1rem;;
  }

  ul {
    list-style: none;
    padding: 0;
    margin: 0;

    &:last-child {
      border-bottom: 1px solid $alto;
    }

    a {
      color: inherit;
    }

    li {
      padding: 5px 20px;
      transition: all .2s ease-in-out;
      cursor: pointer;
      border-left: 5px solid $alto;
      margin-bottom: 20px;

      &:hover {
        background-color: $babyPowder;
      }

      span {
        color: $tuftsBlue;
        transition: all .2s ease-in-out;

        &.contract {
          padding-left: 5px;
        }
      }
      span:hover {
        text-decoration: underline;
      }
    }
  }

}
</style>
